import {Component, inject, input} from '@angular/core';
import {NgForOf, NgIf} from '@angular/common';
import {ShowEventDate} from '../../../../common/pipe/showEventDate.pipe';
import {ShowFreeDate} from '../../../../common/pipe/showFreeDate.pipe';
import {SubscriptionContextV2Service} from '../../../../services/subscription-v2-context.service';
import {RemoteConfig} from '../../../config/remote-config';
import {SessionResources} from '../../../../resources/session.resources';
import {Router} from '@angular/router';

@Component({
  selector: 'app-sub-v2-header',
  imports: [
    NgForOf,
    NgIf,
    ShowEventDate,
    ShowFreeDate
  ],
  templateUrl: './sub-v2-header.component.html',
})
export class SubV2HeaderComponent {

  sessionId = input<string>()
  subscriptionContextV2Service = inject(SubscriptionContextV2Service)
  remoteConfig = inject(RemoteConfig)
  sessionResources = inject(SessionResources)
  router = inject(Router)

}
